import { Component } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { Button } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'mon-profile-limit-reached-dialog',
    imports: [
        TranslocoModule,
        Button,
    ],
    templateUrl: './profile-limit-reached-dialog.component.html',
    styleUrls: ['./profile-limit-reached-dialog.component.scss'],
})
export class ProfileLimitReachedDialogComponent {
    constructor (
        private readonly dialogRef: DynamicDialogRef,
    ) {}

    cancel (): void {
        this.dialogRef.close(null);
    }

    confirm (): void {
        this.dialogRef.close(true);
    }
}
